import React, { useState } from 'react';
import CurrencyInput from "react-currency-input-field";
import Swal from 'sweetalert2';
import api from '../../../../config/axios';

import { FaRegSave, FaTimes } from 'react-icons/fa';

const FecharCaixaModal = ({ onClose, onCaixaAtualizado, caixa }) => {
    const formatarValorComVirgula = (valor) => {
        if (valor === undefined || valor === null) return '0,00';
        const numero = typeof valor === 'string' ? parseFloat(valor) : valor;
        return numero.toFixed(2).replace('.', ',');
    };

    const [formData, setFormData] = useState({
        data_hora: new Date().toLocaleString('pt-BR').replace(',', ''),
        observacoes: caixa.observacoes,
        dinheiro: {
            sistema: formatarValorComVirgula(caixa?.total_dinheiro || 0),
            real: formatarValorComVirgula(caixa?.total_dinheiro || 0),
            diferenca: '0,00',
            label: 'Dinheiro'
        },
        cheque: {
            sistema: formatarValorComVirgula(caixa?.total_cheque || 0),
            real: formatarValorComVirgula(caixa?.total_cheque || 0),
            diferenca: '0,00',
            label: 'Cheque'
        },
        cartao_credito: {
            sistema: formatarValorComVirgula(caixa?.total_credito || 0),
            real: formatarValorComVirgula(caixa?.total_credito || 0),
            diferenca: '0,00',
            label: 'Cartão de Crédito'
        },
        cartao_debito: {
            sistema: formatarValorComVirgula(caixa?.total_debito || 0),
            real: formatarValorComVirgula(caixa?.total_debito || 0),
            diferenca: '0,00',
            label: 'Cartão de Débito'
        },
        pix: {
            sistema: formatarValorComVirgula(caixa?.total_pix || 0),
            real: formatarValorComVirgula(caixa?.total_pix || 0),
            diferenca: '0,00',
            label: 'Pix'
        },
        boleto: {
            sistema: formatarValorComVirgula(caixa?.total_boleto || 0),
            real: formatarValorComVirgula(caixa?.total_boleto || 0),
            diferenca: '0,00',
            label: 'Boleto'
        },
        ted: {
            sistema: formatarValorComVirgula(caixa?.total_ted || 0),
            real: formatarValorComVirgula(caixa?.total_ted || 0),
            diferenca: '0,00',
            label: 'TED'
        },
        doc: {
            sistema: formatarValorComVirgula(caixa?.total_doc || 0),
            real: formatarValorComVirgula(caixa?.total_doc || 0),
            diferenca: '0,00',
            label: 'DOC'
        },
        cortesia: {
            sistema: formatarValorComVirgula(caixa?.total_cortesia || 0),
            real: formatarValorComVirgula(caixa?.total_cortesia || 0),
            diferenca: '0,00',
            label: 'Cortesia'
        }
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const converterParaNumero = (valorFormatado) => {
        if (!valorFormatado) return 0;
        let valor = valorFormatado.replace(/R\$\s?/g, '').trim();
        valor = valor.replace(/\./g, '').replace(',', '.');
        return parseFloat(valor) || 0;
    };

    const formatarParaCurrencyInput = (numero) => {
        const valorComPonto = numero.toFixed(2);
        return valorComPonto.replace('.', ',');
    };

    const handleInputChange = (tipo, campo, valor) => {
        const valorString = valor || '0';
        const valorNumerico = converterParaNumero(valorString);
        const sistemaNumerico = converterParaNumero(formData[tipo].sistema);

        let diferenca = 0;
        if (campo === 'real') {
            diferenca = Math.abs(valorNumerico - sistemaNumerico);
        } else {
            diferenca = converterParaNumero(formData[tipo].diferenca);
        }

        const diferencaFormatada = formatarParaCurrencyInput(diferenca);

        setFormData(prev => ({
            ...prev,
            [tipo]: {
                ...prev[tipo],
                [campo]: valorString || '0,00',
                diferenca: campo === 'real' ? diferencaFormatada : prev[tipo].diferenca
            }
        }));
    };

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();

        try {
            const result = await Swal.fire({
                title: 'Atenção!',
                text: 'Confirmar o fechamento do caixa?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim, confirmar!',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) {
                return;
            }

            setIsSubmitting(true);

            const dadosParaEnvio = {
                caixa_id: caixa.id,
                data_hora: formData.data_hora,
                observacoes: formData.observacoes,
                total_dinheiro: converterParaNumero(formData.dinheiro.real),
                total_cheque: converterParaNumero(formData.cheque.real),
                total_credito: converterParaNumero(formData.cartao_credito.real),
                total_debito: converterParaNumero(formData.cartao_debito.real),
                total_pix: converterParaNumero(formData.pix.real),
                total_boleto: converterParaNumero(formData.boleto.real),
                total_ted: converterParaNumero(formData.ted.real),
                total_doc: converterParaNumero(formData.doc.real),
                total_cortesia: converterParaNumero(formData.cortesia.real)
            };

            await api.post('/caixas/fechar', dadosParaEnvio);

            Swal.fire('Sucesso', 'Caixa fechado com sucesso!', 'success');
            if (onCaixaAtualizado) {
                onCaixaAtualizado();
            }

            onClose();

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Erro ao fechar caixa',
                text: error.response.data.message || 'Ocorreu um erro ao fechar o caixa. Por favor, tente novamente.',
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">Fechar Caixa</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row align-items-end">
                                <div className="col-lg-6 col-12">
                                    <div className="mb-3">
                                        <label className="form-label fw-bold">Data e Hora</label>
                                        <input type="text" className="form-control" value={formData.data_hora} disabled />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-12">
                                    <p className="mb-2">Confira se os valores presentes em seu caixa estão de acordo com as informações abaixo:</p>
                                </div>
                            </div>

                            <div className="row align-items-end mt-3">
                                <div className="col-12">
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead className="table-custom-primary">
                                                <tr>
                                                    <th className="text-nowrap" style={{minWidth: '150px', width: '150px'}}>Tipo Pagamento</th>
                                                    <th className="text-nowrap" style={{minWidth: '150px', width: '150px'}}>Sistema (R$)</th>
                                                    <th className="text-nowrap" style={{minWidth: '150px', width: '150px'}}>Real (R$)</th>
                                                    <th className="text-nowrap" style={{minWidth: '150px', width: '150px'}}>Diferença (R$)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {['dinheiro', 'cheque', 'cartao_credito', 'cartao_debito', 'pix', 'boleto', 'ted', 'doc', 'cortesia'].map((tipo) => (
                                                    <tr key={tipo}>
                                                        <td className="text-nowrap">{formData[tipo].label}</td>
                                                        <td>
                                                            <CurrencyInput
                                                                className="form-control"
                                                                value={formData[tipo].sistema}
                                                                disabled
                                                                decimalsLimit={2}
                                                                prefix="R$ "
                                                                placeholder="R$ 0,00"
                                                                decimalSeparator=","
                                                                groupSeparator="."
                                                                autoComplete="off"
                                                            />
                                                        </td>
                                                        <td>
                                                            <CurrencyInput
                                                                className="form-control"
                                                                value={formData[tipo].real}
                                                                onValueChange={(value) => handleInputChange(tipo, 'real', value)}
                                                                decimalsLimit={2}
                                                                prefix="R$ "
                                                                placeholder="R$ 0,00"
                                                                decimalSeparator=","
                                                                groupSeparator="."
                                                                autoComplete="off"
                                                            />
                                                        </td>
                                                        <td>
                                                            <CurrencyInput
                                                                className="form-control"
                                                                value={formData[tipo].diferenca}
                                                                disabled
                                                                decimalsLimit={2}
                                                                prefix="R$ "
                                                                placeholder="R$ 0,00"
                                                                decimalSeparator=","
                                                                groupSeparator="."
                                                                autoComplete="off"
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="row mt-3">
                                <div className="col-12">
                                    <div className="mb-3">
                                        <label className="form-label fw-bold">Observações</label>
                                        <textarea className="form-control" value={formData.observacoes} onChange={(e) => setFormData({ ...formData, observacoes: e.target.value })} rows={5}/>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer mt-4">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose} disabled={isSubmitting}>
                                    <FaTimes /> Fechar
                                </button>
                                <button className="btn btn-custom-primary ms-3" type="button" onClick={handleSubmit} disabled={isSubmitting}>
                                    {isSubmitting ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Salvando...
                                        </>
                                    ) : (
                                        <>
                                            <FaRegSave /> Salvar
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default FecharCaixaModal;
